// Zentrale API-Base-URL.
// Im deployed Browser (egal welche Custom Domain) nutzen wir IMMER die aktuelle
// Origin, sodass Frontend und Backend dieselbe Origin sind — damit gibt es keine
// CORS-Konflikte mit Cookies/Credentials.
// Nur in lokaler Entwicklung (localhost) verwenden wir die ENV-Variable,
// weil dort Frontend (3000) und Backend (8001) auf verschiedenen Ports laufen
// und ein direkter Aufruf der Backend-URL nötig ist.
const isBrowser = typeof window !== 'undefined';
const isLocalhost = isBrowser && (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1'
);

export const API_BASE = (isBrowser && !isLocalhost)
  ? window.location.origin
  : (process.env.REACT_APP_BACKEND_URL || '');
